export default __webpack_public_path__ + "static/media/topic-language.150e4552.svg";